<template>
  <div class="page-coainer">
    <div>
      <section v-if="isErrMessage" id="note">
        <md-card class="p-3">
          <div v-html="errMessage" />
        </md-card>
      </section>

      <section id="login-form">
        <form
          class="md-layout text-center col-11 mx-auto"
          @submit.prevent="validate"
        >
          <md-card class="form">
            <md-card-header class="p-2">
              <h4 class="mt-2">ログイン</h4>
            </md-card-header>
            <md-card-content>
              <div class="md-layout md-gutter mt-3">
                <div class="md-layout-item">
                  <input
                    type="text"
                    :class="[
                      'form-control',
                      { 'border-red': $v.form.USER_ID.$error },
                    ]"
                    @change="$v.form.USER_ID.$touch()"
                    v-model="form.USER_ID"
                    :maxlength="20"
                    placeholder="ID"
                    :disabled="sending"
                  />
                  <div v-if="$v.form.USER_ID.$error" class="err-message">
                    <p v-if="!$v.form.USER_ID.required">入力必須です</p>
                  </div>

                  <input
                    type="password"
                    :class="[
                      'form-control mt-2',
                      { 'border-red': $v.form.PASSWORD.$error },
                    ]"
                    @change="$v.form.PASSWORD.$touch()"
                    v-model="form.PASSWORD"
                    :maxlength="20"
                    placeholder="Password"
                    :disabled="sending"
                  />
                  <div v-if="$v.form.PASSWORD.$error" class="err-message">
                    <p v-if="!$v.form.PASSWORD.required">入力必須です</p>
                  </div>
                </div>
              </div>
              <md-button class="md-raised" type="submit">ログイン</md-button>
              <p class="my-2">
                <router-link to="/password">
                  <a>パスワードをお忘れの方はこちら</a>
                </router-link>
              </p>
              <p>
                <md-button
                  id="new-apply-btn"
                  :style="{ width: isMobile ? 'auto' : '300px' }"
                  type="button"
                  class="btn-success base-btn p-2"
                  @click="showApplyDialog = true"
                >
                  新規お取引申込フォーム
                </md-button>
              </p>
            </md-card-content>
          </md-card>
        </form>
      </section>

      <p class="text-center">
        <router-link to="/kiyaku">
          <a>サイト利用規約</a>
        </router-link>
      </p>
    </div>

    <!-- 新規申し込み -->
    <md-dialog
      :md-active.sync="showApplyDialog"
      id="apply-modal"
      class="new w-600"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
    >
      <md-dialog-title>新規お取引申込フォーム</md-dialog-title>
      <div class="p-2 p-md-offset modal-content">
        <div class="pt-md-3">
          <div class="btn-wrapper">
            <p>
              <md-button
                type="button"
                class="btn-success base-btn"
                :to="{ name: 'ApplyUsed' }"
              >
                中古車販売店・ディーラー・
                <br v-if="isMobile" />
                輸出企業のお客様
              </md-button>
            </p>
            <p>
              <md-button
                type="button"
                class="btn-success base-btn"
                :to="{ name: 'ApplyLease' }"
              >
                リース会社・リース車両をご利用の方・
                <br />
                その他法人のお客様
              </md-button>
            </p>
            <p>
              <md-button
                type="button"
                class="btn-success base-btn"
                @click="
                  _alert(
                    '大変申し訳ございません。<br>現在個人のお客様のお申し込みは受付けておりません。'
                  )
                "
              >
                個人のお客様
              </md-button>
            </p>
          </div>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showApplyDialog = false">
          閉じる
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-alert
      class="new pink"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="
        scroll('clear')
        login()
      "
      :md-active.sync="isIEDialog"
      md-content="<strong>ブラウザ「Internet Explore」は非推奨です。<br>操作に支障をきたす恐れがある為、<br>他ブラウザを利用することを強くお勧めいたします。</strong>"
    />
  </div>
</template>

<script>
import Mixin from './mixin/Mixin'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  name: 'Login',
  mixins: [validationMixin, Mixin],
  data: () => ({
    showApplyDialog: false,

    form: {
      USER_ID: null,
      PASSWORD: null,
    },

    isErrMessage: false,

    errMessage: null,

    isValidationClass: {
      USER_ID: null,
      PASSWORD: null,
    },

    invalid: false,

    sending: false,

    errorMessages: [],

    /** IE利用警告ダイアログ表示フラグ */
    isIEDialog: false,
  }),
  validations: {
    form: {
      USER_ID: {
        required,
      },
      PASSWORD: {
        required,
      },
    },
  },
  computed: {
    accessToken() {
      return this.$store.state.auth.ACCESS_TOKEN
    },
    height() {
      return Store.state.screen.height
    },
  },
  methods: {
    login() {
      this.spinerOn()
      this.$store
        .dispatch('auth/checkDuplicationLogin', this.form)
        .then((res) => {
          // 権限によりログイン先を変更
          this.$router.push({
            name:
              Store.state.user.data.ROLE === Constant.USER.ROLE.ADMIN
                ? 'AdminIndex'
                : 'Home',
          })
        })
        .catch((err) => {
          this.errMessage = err.message.replace(/Error:/g, '')
          this.isErrMessage = true
          this.spinerOff()
        })
    },
    validate() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.invalid = false
        this.isIE ? (this.isIEDialog = true) : this.login()
      } else {
        this.invalid = true
      }
    },
  },
  beforeCreate() {
    Store.commit('auth/destroy')
    Store.commit('user/destroy')
    Store.commit('vehicle/destroy')
  },
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
section#note
  .md-card
    width: 50%
    margin: 5px auto
    background: pink
    color: red
    font-weight: bold
    @include sp
      font-size: 14px
      margin: 10px auto
      width: 100%

section#login-form
  .md-card-header
    background: $baseBlueColor
    color: white
  .form
    width: 50%
    margin: 40px auto
    @include sp
      margin: 10px auto
      width: 100%
  .md-button
    @extend.base-btn
    @extend.f-size-16
    background: $baseGreenColor
    border-radius: 5px
#apply-modal
  .btn-wrapper
    text-align: center
    .md-button
      width: 90%
      font-size: 18px
  @include sp
    .btn-wrapper
      .md-button
        font-size: 16px
.err-message
  p
    text-align: left
</style>

<style lang="sass">
@import '../assets/css/logico2'
#new-apply-btn
  @extend.base-btn
  @extend.f-size-16
  background: orange !important
  border-radius: 5px
  .md-button-content
    color: black
</style>



// WEBPACK FOOTER //
// src/components/Login.vue